<template>
    <rkm-area
        background-color="warning"
        closed
        header-prefix-text="A"
        title="Avaliação"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <Item
                    :get-value="() => item.avaliacao.descricao"
                    label="Impressões adicionais sobre a avaliação dos problemas/condições detectados"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProblemaCondicao :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxPreNatal
                    v-if="item.preNatal.isPrimeiroAtendimento"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxEncerramentoGestacao
                    v-if="item.preNatal.desfechoEm"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <template v-if="item.isAtendimentoSaudeBucal">
            <rkm-row class="mt-3">
                <rkm-col cols="12">
                    <Item
                        :get-value="() => item.saudeBucal.vigilancias.join(', ')"
                        label="Vigilância em saúde bucal"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <Item
                        :get-value="() => item.saudeBucal.necessidadeProteseInferiorSuperior === true
                            ? 'Sim' : (item.saudeBucal.necessidadeProteseInferiorSuperior === false ? 'Não' : 'Não informado')"
                        label="Necessidade de prótese inferior/superior"
                    />
                </rkm-col>
            </rkm-row>
        </template>
    </rkm-area>
</template>

<script>
// Components.
import BoxEncerramentoGestacao from './components/encerramento-gestacao/Index'
import BoxPreNatal from '@/components/ambulatorio/atendimento/components/historico/components/pre-natal/Index'
import BoxProblemaCondicao from './components/problema-condicao/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        BoxEncerramentoGestacao,
        BoxPreNatal,
        BoxProblemaCondicao,
        Item
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>